export const byChannelId = (id) => (item) => id === item.channelId;
export const byParentChannelId = (id) => (item) => id === item.parentChannelId;
export const byRegionId = (id) => (item) => id === item.regionId;
export const byAgencyId = (id) => (item) => id === item.agencyId;
export const byManager = (name) => (item) => name === item.manager;
export const bySeller = (name) => (item) => name === item.seller;

// takes array of ids and array of objects
// and returns only those objects that have id or login that is in array of ids
export const restrictBy =
	(by = []) =>
	(what = []) => {
		return by.length > 0 ? what.filter((x) => by.some((y) => y === x.id || y === x.login)) : what;
	};

export const toUserName = (user) => {
	const login = user.login ? `- ${user.login.replace(/\w+\\/, '')}` : '';
	let fullName = `${user.surname || ''} ${user.firstName || ''}`.trim();
	if (user.existsUsersWithTheSameName) {
		fullName = `${fullName} ${login}`.trim();
	}

	return {
		...user,
		fullName,
	};
};
